export enum ApiRootLinkRel {
	ADMIN = 'admin',
	VORGANGS = 'vorgangs',
	VERFUEGUNGS = 'verfuegungs',
	VERFAHRENS = 'verfahrens',
	LAST_OPENED_VERFAHRENS = 'lastOpenedVerfahrens',
	KONTAKTS = 'kontakts',
	KONTAKTS_BY_NAME = 'kontaktsByName',
	VORGAENGE_IN_RUECKLAUF = 'vorgaengeInRuecklauf',
	VORGAENGE_IN_WIEDERVORLAGE = 'vorgaengeInWiedervorlage',
	WIEDERVORLAGEN_FRISTEN = 'fristen',
	VORGAENGE_RECHTSPFLEGE = 'vorgaengeFuerRechtspfleger',
	VORLAGES = 'vorlages',
	LANDS = 'lands',
	HEIMATHAFENS = 'heimathafens',
	RECHTSPFLEGERS = 'rechtspflegers',
	SIGNATURE_VALIDATOR_RESPONSES = 'signatureValidationResponses',
	STATISTIK = 'statistik',
	TRANSLATION = 'translation',
	USIGNAL_BY_VALUE = 'usignalByValue',
	EXPORT_REGISTER = 'exportRegister',
}
